// Resolve the public site origin from the current admin location.
// Production: admin runs at :7080, site at :7001 on the same host.
// Local dev: admin Vite at :5173, site Nuxt at :3001.
// Override with VITE_PUBLIC_SITE_URL env var when neither pattern applies.

export function useSiteUrl() {
  if (typeof window === 'undefined') return '';

  const fromEnv = import.meta.env.VITE_PUBLIC_SITE_URL;
  if (fromEnv) return fromEnv.replace(/\/+$/, '');

  const { protocol, hostname, port } = window.location;
  // Prod'da admin ayrı subdomain'de yayında (admin.vip-travellers.co.uk veya
  // adminvip.maxirez.com); public site ana host'ta. "admin" önekini atmazsak
  // "Siteye git" linkleri admin'in kendisine gider. Local'de (localhost) önek
  // yok, etkisiz.
  const siteHost = hostname.replace(/^admin\.?/, '');
  let sitePort = port;
  if (port === '7080') sitePort = '7001';
  else if (port === '5173') sitePort = '3001';
  else if (!port || port === '80' || port === '443') sitePort = '';

  return `${protocol}//${siteHost}${sitePort ? ':' + sitePort : ''}`;
}

// Build a full URL to a public-site page.
// kind: 'hotel' | 'villa' | 'room' | 'service' | 'location' | 'blog' | 'promotion'
export function publicUrl(kind, params = {}) {
  const base = useSiteUrl();
  const lang = params.lang || 'en';
  const slug = params.slug || '';

  switch (kind) {
    case 'hotel':     return slug ? `${base}/${lang}/hotels/${slug}` : `${base}/${lang}/hotels`;
    case 'villa':     return slug ? `${base}/${lang}/villas/${slug}` : `${base}/${lang}/villas`;
    case 'room':      return params.hotelSlug ? `${base}/${lang}/hotels/${params.hotelSlug}` : '';
    case 'service':   return slug ? `${base}/${lang}/services/${slug}` : `${base}/${lang}/services`;
    case 'location':  return slug ? `${base}/${lang}/turkiye/${slug}` : `${base}/${lang}`;
    case 'blog':      return slug ? `${base}/${lang}/blog/${slug}` : `${base}/${lang}/blog`;
    case 'promotion': return slug ? `${base}/${lang}/offers/${slug}` : `${base}/${lang}/offers`;
    case 'home':      return `${base}/${lang}`;
    default:          return base;
  }
}
